import type { FaireProductEntity } from "../../entity_types/product";

export const p_mu9kbx4fps: FaireProductEntity = {
  token: "p_mu9kbx4fps",
  type: "product",
  name: "You Are My Everything Greeting Card",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/fcf940033ca15485ba5d539919ee9c8fc839f85eb23a4a4e1242ab27b0d5cadd.png",
  galleryImageUrls: [],
  priceDollars: 2.75,
  description: "Everyone knows a coffee + bagel is the perfect pair! A thoughtful greeting card for someone special.\n\n𝐆𝐨𝐨𝐝 𝐭𝐨 𝐤𝐧𝐨𝐰:\n• Blank on the inside\n• A2\n• Includes colored envelope\n• Individually wrapped in a cellophane sleeve or plastic free with a removable sticker clasp.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:01.850Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
